import { InputBase as MInputBase } from '@mantine/core';
import classes from './inputBase.module.scss';

export const InputBase = MInputBase.extend({
  classNames: classes,
});
